<template>
  <v-row
    justify=center>
    <v-col
      cols=auto>
      <v-card
        width=800
        class="main--text">
        <v-form>
          <v-container
            fluid>
            <v-row
              no-gutters
              align=center
              justify=space-between>
              <v-col
                cols=auto><span class="font-weight-bold" style="font-size:1.3rem">ご登録情報変更画面</span>
                </v-col>
              <v-col
                cols=auto>
                  <v-icon
                    @click="$emit('return-button-click')">mdi-arrow-left-circle</v-icon>
              </v-col>
            </v-row>
            <v-row
              dense>
              <v-col
                cols=12
                md=6
                sm=6>
                <v-text-field
                  v-model="personalName"
                  label="名"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="personalName"
                  data-vv-as="名前"
                  required
                  :error-messages="errors.collect('personalName')"
                  >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              dense>
              <v-col
                cols=12
                md=6
                sm=6>
                <v-text-field
                  v-model="flatPersonalName"
                  label="メイ"
                  type="text"
                  v-validate="'required'"
                  data-vv-name="flatPersonalName"
                  data-vv-as="名前（カナ）"
                  required
                  :error-messages="errors.collect('flatPersonalName')"
                  >
                </v-text-field>
              </v-col>
            </v-row>
            <v-row
              no-gutters>
              <v-col>
                <v-radio-group
                  v-model="gender"
                  row
                  v-validate="'required'"
                  data-vv-name="gender"
                  data-vv-as="性別"
                  required
                  :error-messages="errors.collect('gender')">
                  <v-radio
                    label="男性"
                    value="male">
                  </v-radio>
                  <v-radio
                    label="女性"
                    value="female">
                  </v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row
              no-gutters>
              <v-col
                md=6>
                <BirthdayPicker v-model="birthday"/>
              </v-col>
            </v-row>
            <v-row
              no-gutters>
              <v-col
                class="font-weight-bold"
                >受講希望時間帯</v-col>
            </v-row>
              <div
                v-for="(availableSchedule, index) in availableSchedules.get()"
                :key="index"
              >
                <span class="caption grey--text text--darken-1">
                  時間帯{{index+1}}
                </span>
                <v-row
                  no-gutters>
                  <v-col>
                    <ScheduleEditor
                      v-model="availableSchedules.get()[index]"
                      @addNewLine="$emit('add-schedule-button-click')"
                      @deleteLine="$emit('delete-schedule-button-click', availableSchedule)"/>
                  </v-col>
                </v-row>
              </div>
            <v-row
              justify=start
              >
              <v-col>
                <v-btn
                  outlined
                  rounded
                  color="primary"
                  @click="update"
                  >更新
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import BirthdayPicker from "@/components/molecules/BirthdayPicker.vue"
import ScheduleEditor from "@/components/molecules/ScheduleEditor.vue"

export default {
  components: {
    BirthdayPicker,
    ScheduleEditor
  },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    updateValue (diff) {
      this.$emit("input", { ...this.value, ...diff })
    },
    update () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("update-button-click")
          // this.dialog = true
        }
      })
    },
    toDisplay () {
      this.dialog = false
      this.$emit("return-button-click")
    }
  },
  computed: {
    name: {
      get() {
        return this.value.name
      },
      set(name) {
        this.updateValue({ name })
      }
    },
    personalName: {
      get () {
        return this.name.personalName
      },
      set (personalName) {
        this.name = { ...this.name, personalName }
      }
    },
    flatPersonalName: {
      get () {
        return this.name.flatPersonalName
      },
      set (flatPersonalName) {
        this.name = { ...this.name, flatPersonalName }
      }
    },
    gender: {
      get () {
        return this.value.gender
      },
      set (gender) {
        this.updateValue({ gender })
      }
    },
    birthday: {
      get() {
        return this.value.birthday
      },
      set (birthday) {
        this.updateValue({ birthday })
      }
    },
    availableSchedules: {
      get() {
        return this.value.availableSchedules
      },
      set(availableSchedules) {
        this.updateValue({ availableSchedules })
      }
    }
  }
}
</script>
